import {Flex, Text, Icon} from '@spothero/ui';
import PropTypes from 'prop-types';
import React from 'react';
import PriceTag from '@spothero/icons/price-tag';

const compactStyles = {
    width: 'fit-content',
    borderRadius: '0.5rem',
    marginTop: '1rem',
    paddingX: '2',
};

const DynamicVisualFlag = ({isPartialBanner, title, isCompact}) => {
    return (
        <Flex
            display={isPartialBanner && 'inline-flex'}
            alignItems="center"
            paddingX="4"
            paddingY="1"
            marginLeft={isPartialBanner && '-1rem'}
            marginTop={isPartialBanner && '-0.5rem'}
            marginBottom={isPartialBanner && '0.5rem'}
            backgroundColor="green.100"
            borderTopRadius={!isPartialBanner && '0.5rem'}
            borderEndRadius={isPartialBanner && '1rem'}
            {...(isCompact ? compactStyles : {})}
            data-testid={`DynamicVisualFlag-${encodeURIComponent(title)}`}
        >
            <Icon as={PriceTag} />
            <Text paddingLeft="2" fontSize="sm" fontWeight="semibold">
                {title}
            </Text>
        </Flex>
    );
};

DynamicVisualFlag.propTypes = {
    isPartialBanner: PropTypes.bool,
    title: PropTypes.string,
    isCompact: PropTypes.bool,
};

export default DynamicVisualFlag;
